/* eslint-disable guard-for-in */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import Loader from '../../Common/Loader';
import { cookieStorageUtility, localStorageUtility } from '../../../utils/utilityFunctions';
import MappingData from './MappingDetails/MappingData';
import EditMapping from './MappingDetails/EditMapping';
import constants from '../../../constants';
import { checkRole } from '../../Common/CheckRole';
import { Link, useNavigate, useParams } from 'react-router-dom';


const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const ChannelDetails = (props) => {
  const { channelDetail } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [showUILoader, setShowUILoader] = useState(false);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [showError, setShowError] = useState(false);
  const [message, setMessage] = useState('');
  const [otaData, setOtaData] = useState({});
  const [channelStatus, setChannelStatus] = useState('');
  const [showEditMapping, setShowEditMapping] = useState(true);
  const [showMappingData, setShowMappingData] = useState(false);
  const [currencyList, setCurrencyList] = useState([]);
  const [categoryOptionsObject, setCategoryOptionsObject] = useState([]);
  const [pmsCategorySelected, setPmsCategorySelected] = useState([]);
  const [mappingParam, setMappingParam] = useState({ mapping: {} });

  useEffect(() => {
    const mappingParamInit = { mapping: {} };
    getCurrencyList();

    const otaDataInit = JSON.parse(atob(channelDetail));
    mappingParamInit.channelId = otaDataInit.channel_id;
    mappingParamInit.otaType = otaDataInit.ota_model_name;
    if (typeof otaDataInit.connected !== 'undefined') {
      mappingParamInit.sync = 'edit';
      setOtaData(otaDataInit);
      setShowMappingData(true);
      setShowEditMapping(false);
      setMappingParam(mappingParamInit);
      getStatus(otaDataInit);
      getChannelConfig('edit', otaDataInit, mappingParamInit);
    } else {
      mappingParamInit.sync = 'add';
      setOtaData(otaDataInit);
      setShowMappingData(false);
      setShowEditMapping(true);
      setMappingParam(mappingParamInit);
    }
    // eslint-disable-next-line
  }, []);
  const getCurrencyList = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    const identity = localStorageUtility.fetch('identity');
    setShowUILoader(true);
    axios(serverUrl + 'common/currencylist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        assignRegionType: identity.assign_region_type,
        assignRegionValue: identity.assign_region_value
      }
    }).then(response => {
      if (response.status === 200) {
        setCurrencyList(response.data.currencyList);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const getStatus = (otaDataArg = otaData) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(false);
    // setShowUILoader(true);
    axios(serverUrl + 'channel/getstatus', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        channelId: otaDataArg.channel_id
      }
    }).then(response => {
      if (response.data.responseCode) {
        setChannelStatus(response.data.data === 1 ? 'active' : 'de-active');
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const changeStatus = (val) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/changestatus', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        channelId: otaData.channel_id,
        status: val === true ? 1 : 0
      }
    }).then(response => {
      if (response.data.responseCode) {
        showMessage('success', response.data.message);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
      getStatus();
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const reSyncData = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/resyncdata', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        channelId: otaData.channel_id
      }
    }).then(response => {
      if (response.data.responseCode) {
        showMessage('success', response.data.message);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
      getStatus();
      getChannelConfig('edit');
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const disconnect = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/disconnect', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        channelId: otaData.channel_id
      }
    }).then(response => {
      if (response.data.responseCode) {
        showMessage('success', response.data.message);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
      navigate('/channelmanager/mychannel');
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const getChannelConfig = async (syc, otaDataArg = otaData, mappingParamArg = mappingParam) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    return await axios(serverUrl + 'channel/getchannelconfig', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        channelHotelId: mappingParamArg.channelHotelId || '',
        channelType: otaDataArg.ota_model_name.toLowerCase(),
        currency: mappingParamArg.currency || '',
        channelId: otaDataArg.channel_id,
        username: mappingParamArg.username || '',
        password: mappingParamArg.password || '',
        syc,
        distributor_id: 1,
        activity_user_id: authUserId,
        user_ip_address: '127.0.0.1'
      }
    }).then(response => {
      let flag = true;
      if (typeof response.data !== 'undefined' && response.data.responseCode) {
        preparedChannelData(response.data.data);
        setData(response.data.data);
      } else {
        showConfigMessage(true, response.data.message);
        flag = false;
      }
      setShowUILoader(false);
      return flag;
    }).catch(error => {
      console.log(error, syc);
      setShowUILoader(false);
      return false;
    });
  };

  const setChannelConfig = () => {
    setShowUILoader(true);
    const otaDataLocal = JSON.parse(atob(channelDetail));
    axios(serverUrl + 'channel/setchannelconfig', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: mappingParam
    }).then(response => {
      if (response.data.responseCode) {
        showMessage('success', response.data.message);
        otaDataLocal.connected = true;
        setTimeout(() => {
          navigate('/channelmanager/mychannel/channeldetails/' + btoa(JSON.stringify(otaDataLocal)));
          window.location.reload();
        }, 1000);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const preparedChannelData = (data) => {
    const {
      mappedArray,
      pmsArray
    } = data;
    let categoryOptionsObject = [];
    
    for (const mappedKey in mappedArray.categories) {
      if (Object.hasOwnProperty.call(mappedArray.categories, mappedKey)) {
        const mappedValue = mappedArray.categories[mappedKey];
        categoryOptionsObject[mappedKey] = {};
        for (const pmsKey in pmsArray.categories) {
          if (Object.hasOwnProperty.call(pmsArray.categories, pmsKey)) {
            const pmsValue = pmsArray.categories[pmsKey];
            let rooms = [];
            for (let i = 1; i <= pmsValue.total_rooms; i++) {
              rooms.push(i);
            }
            categoryOptionsObject[mappedKey][pmsKey] = {};
            categoryOptionsObject[mappedKey][pmsKey].otaCatId = mappedValue.ota_cat_id;
            categoryOptionsObject[mappedKey][pmsKey].otaOcc = mappedValue.occ;
            categoryOptionsObject[mappedKey][pmsKey].otaExtrabed = mappedValue.ota_max_extrabed;
            categoryOptionsObject[mappedKey][pmsKey].pmsCatId = pmsKey;
            categoryOptionsObject[mappedKey][pmsKey].pmsOcc = ((pmsValue.hasOwnProperty('baseOcc')) ? pmsValue.pms_base_occupancy : pmsValue.pms_max_occupancy);
            categoryOptionsObject[mappedKey][pmsKey].pmsExtrabed = pmsValue.pms_extrabed_occupancy;
            categoryOptionsObject[mappedKey][pmsKey].otaCatName = mappedValue.ota_cat_name;
            categoryOptionsObject[mappedKey][pmsKey].roomCategoryType = mappedValue.room_category_type;
            categoryOptionsObject[mappedKey][pmsKey].totalRoom = rooms;
            categoryOptionsObject[mappedKey][pmsKey].categoryBookingModel = mappedValue.category_booking_model;
            categoryOptionsObject[mappedKey][pmsKey].pmsCatName = pmsValue.pms_cat_name + ' (' + pmsValue.pms_cat_code + ') ' + pmsValue.pmsbasemaxocc;
            categoryOptionsObject[mappedKey][pmsKey].extra_details = typeof mappedValue.extra_detail !== 'undefined' && mappedValue.extra_detail !== null ? mappedValue.extra_detail[0] : {};
            categoryOptionsObject[mappedKey][pmsKey].minThreshold = mappedValue.mini_rate_threshold !== null ? mappedValue.mini_rate_threshold : '';
            categoryOptionsObject[mappedKey][pmsKey].decreaseInventory = mappedValue.decrease_inventory !== null ? mappedValue.decrease_inventory : '';
          }
        }
      }
    }
    let pmsCategorySelected = [];
    let i = 0;
    let newMappingData = {};
    
    for (const key in mappedArray.categories) {
      if (Object.hasOwnProperty.call(mappedArray.categories, key)) {
        const value = mappedArray.categories[key];
        if (value.pms_cat_id !== '' && value.pms_cat_name !== '') {
          pmsCategorySelected[i] = categoryOptionsObject[value.ota_cat_id][value.pms_cat_id];
          const rateplans = value.rateplans;
          let otaRpId = '';
          let pmsRpId = '';
          let markup_rate_flat = '';
          let markup_rate_per = '';
          let manual_price = '';
          let system_rate_plan_code = '';
          let partner_status = true;
          let selectedRatePlans = {};
          
          for (const otaRateplanId in rateplans) {
            const rateplan = rateplans[otaRateplanId];
            if (typeof rateplan.pms_rate_plan_details !== 'undefined' && Object.keys(rateplan.pms_rate_plan_details).length > 0) {
              selectedRatePlans = {
                ...selectedRatePlans,
                [otaRateplanId]: {
                  pmsRateplanId: rateplan.pms_rate_plan_details[0].pms_rate_plan_id,
                  otaRateplanId: otaRateplanId,
                  rateplanIds: rateplan.pms_rate_plan_details[0].pms_rate_plan_id + '-' + otaRateplanId,
                  markup_rate_flat: rateplan.markup_rate_flat,
                  markup_rate_per: rateplan.markup_rate_per,
                  manual_price: rateplan.manual_price,
                  system_rate_plan_code: rateplan.system_rate_plan_code,
                  partner_status: rateplan.partner_status
                }
              };

              otaRpId = otaRateplanId;
              pmsRpId = rateplan.pms_rate_plan_details[0].pms_rate_plan_id;
              markup_rate_flat = rateplan.markup_rate_flat;
              markup_rate_per = rateplan.markup_rate_per;
              manual_price = rateplan.manual_price;
              system_rate_plan_code = rateplan.system_rate_plan_code;
              partner_status = rateplan.partner_status;
            }
          }
          newMappingData[value.ota_cat_id] = {
            otaCatId: value.ota_cat_id,
            pmsCatId: value.pms_cat_id,
            ...categoryOptionsObject[value.ota_cat_id][value.pms_cat_id],
            otaCatData: value,
            pmsCatData: pmsArray.categories[value.pms_cat_id],
            min_rate_threshold: categoryOptionsObject[value.ota_cat_id][value.pms_cat_id].minThreshold,
            decrease_inventory: categoryOptionsObject[value.ota_cat_id][value.pms_cat_id].decreaseInventory,
            pmsRateplanId: pmsRpId,
            otaRateplanId: otaRpId,
            markup_rate_flat,
            markup_rate_per,
            manual_price,
            system_rate_plan_code,
            partner_status,
            selectedRatePlans,
            newMapping: false
          };
        }
        i++;
      }
    }
    
    // Use proper state update preserving existing properties including sync
    setMappingParam(prev => ({
      ...prev,
      mapping: newMappingData
    }));
    setCategoryOptionsObject(categoryOptionsObject);
    setPmsCategorySelected(pmsCategorySelected);
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const showConfigMessage = (val, msg) => {
    setShowError(val);
    setMessage(msg);
  };

  const editMapping = (val) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    if (val === 'edit') {
      const {
        data: {
          mappedArray
        }
      } = { data };

      // Use proper state update preserving existing properties including sync
      setMappingParam(prev => ({
        ...prev,
        channelHotelId: mappedArray.channel_hotel_id,
        pmsHotelId: hotelId,
        currency: mappedArray.currency,
        commission: mappedArray.commission,
        obpmodel: mappedArray.obpmodel,
        password: mappedArray.password,
        username: mappedArray.username
      }));
      
      setShowMappingData(false);
      setShowEditMapping(true);
    } else if (val === 'cancel') {
      setShowMappingData(true);
      setShowEditMapping(false);
      setShowError(false);
      setMessage('');
    }
  };

  const handelCategoryChange = (e, otaCatId) => {
    // Use state variables directly instead of destructuring from object literal
    if (e.target.value !== '') {
      let exsitingMapping = {};
      for (const key in pmsCategorySelected) {
        if (Object.hasOwnProperty.call(pmsCategorySelected, key)) {
          const value = pmsCategorySelected[key];
          if (value.pmsCatId === e.target.value && value.otaCatId === otaCatId) {
            const rateplans = data.mappedArray.categories[value.otaCatId].rateplans;
            let otaRpId = '';
            let pmsRpId = '';
            let markup_rate_flat = '';
            let markup_rate_per = '';
            let manual_price = '';
            let system_rate_plan_code = '';
            let partner_status = true;
            let selectedRatePlans = {};
            for (const otaRateplanId in rateplans) {
              const rateplan = rateplans[otaRateplanId];
              if (typeof rateplan.pms_rate_plan_details !== 'undefined' && Object.keys(rateplan.pms_rate_plan_details).length > 0) {
                selectedRatePlans = {
                  ...selectedRatePlans,
                  [otaRateplanId]: {
                    pmsRateplanId: rateplan.pms_rate_plan_details[0].pms_rate_plan_id,
                    otaRateplanId: otaRateplanId,
                    rateplanIds: rateplan.pms_rate_plan_details[0].pms_rate_plan_id + '-' + otaRateplanId,
                    markup_rate_flat: rateplan.markup_rate_flat,
                    markup_rate_per: rateplan.markup_rate_per,
                    manual_price: rateplan.manual_price,
                    system_rate_plan_code: rateplan.system_rate_plan_code,
                    partner_status: rateplan.partner_status
                  }
                };

                otaRpId = otaRateplanId;
                pmsRpId = rateplan.pms_rate_plan_details[0].pms_rate_plan_id;
                markup_rate_flat = rateplan.markup_rate_flat;
                markup_rate_per = rateplan.markup_rate_per;
                manual_price = rateplan.manual_price;
                system_rate_plan_code = rateplan.system_rate_plan_code;
                partner_status = rateplan.partner_status;
              }
            }
            exsitingMapping = {
              [otaCatId]: {
                otaCatId,
                pmsCatId: e.target.value,
                ...categoryOptionsObject[otaCatId][e.target.value],
                otaCatData: data.mappedArray.categories[otaCatId],
                pmsCatData: data.pmsArray.categories[e.target.value],
                min_rate_threshold: value.minThreshold,
                pmsRateplanId: pmsRpId,
                otaRateplanId: otaRpId,
                markup_rate_flat,
                markup_rate_per,
                manual_price,
                system_rate_plan_code,
                partner_status,
                newMapping: false
              }
            };
            break;
          }
        }
      }
      if (Object.keys(exsitingMapping).length > 0) {
        setMappingParam(prev => ({
          ...prev,
          mapping: {
            ...prev.mapping,
            ...exsitingMapping
          }
        }));
      } else {
        setMappingParam(prev => ({
          ...prev,
          mapping: {
            ...prev.mapping,
            [otaCatId]: {
              otaCatId,
              pmsCatId: e.target.value,
              ...categoryOptionsObject[otaCatId][e.target.value],
              otaCatData: data.mappedArray.categories[otaCatId],
              pmsCatData: data.pmsArray.categories[e.target.value],
              min_rate_threshold: '',
              newMapping: true
            }
          }
        }));
      }
    } else {
      setMappingParam(prev => {
        const newMapping = { ...prev.mapping };
        delete newMapping[otaCatId];
        return {
          ...prev,
          mapping: newMapping
        };
      });
    }
  };

  const handelParamChange = (e, otaCatId, type) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    if (type === 'inventory') {
      setMappingParam(prev => ({
        ...prev,
        mapping: {
          ...prev.mapping,
          [otaCatId]: {
            ...prev.mapping[otaCatId],
            decrease_inventory: e.target.value
          }
        }
      }));
    }
    
    if (type === 'threshold') {
      setMappingParam(prev => ({
        ...prev,
        mapping: {
          ...prev.mapping,
          [otaCatId]: {
            ...prev.mapping[otaCatId],
            min_rate_threshold: e.target.value
          }
        }
      }));
    }

    if (type === 'markup_rate_flat') {
      setMappingParam(prev => ({
        ...prev,
        mapping: {
          ...prev.mapping,
          [otaCatId.otaCatId]: {
            ...prev.mapping[otaCatId.otaCatId],
            selectedRatePlans: {
              ...prev.mapping[otaCatId.otaCatId].selectedRatePlans,
              [otaCatId.channelRateplanId]: {
                ...prev.mapping[otaCatId.otaCatId].selectedRatePlans[otaCatId.channelRateplanId],
                markup_rate_flat: e.target.value
              }
            }
          }
        }
      }));
    }
    
    if (type === 'markup_rate_per') {
      setMappingParam(prev => ({
        ...prev,
        mapping: {
          ...prev.mapping,
          [otaCatId.otaCatId]: {
            ...prev.mapping[otaCatId.otaCatId],
            selectedRatePlans: {
              ...prev.mapping[otaCatId.otaCatId].selectedRatePlans,
              [otaCatId.channelRateplanId]: {
                ...prev.mapping[otaCatId.otaCatId].selectedRatePlans[otaCatId.channelRateplanId],
                markup_rate_per: e.target.value
              }
            }
          }
        }
      }));
    }
    
    if (type === 'manual_price') {
      setMappingParam(prev => ({
        ...prev,
        mapping: {
          ...prev.mapping,
          [otaCatId.otaCatId]: {
            ...prev.mapping[otaCatId.otaCatId],
            selectedRatePlans: {
              ...prev.mapping[otaCatId.otaCatId].selectedRatePlans,
              [otaCatId.channelRateplanId]: {
                ...prev.mapping[otaCatId.otaCatId].selectedRatePlans[otaCatId.channelRateplanId],
                manual_price: e.target.value
              }
            }
          }
        }
      }));
    }
    
    if (type === 'rateplan') {
      const selectedValue = e.target.value;
      if (selectedValue) {
        const rateplanIds = selectedValue.split('-');
        const pmsRateplanId = rateplanIds[0];
        const channelRateplanId = rateplanIds[1];
        
        setMappingParam(prev => ({
          ...prev,
          mapping: {
            ...prev.mapping,
            [otaCatId]: {
              ...prev.mapping[otaCatId],
              selectedRatePlans: {
                ...prev.mapping[otaCatId].selectedRatePlans,
                [channelRateplanId]: {
                  pmsRateplanId: pmsRateplanId,
                  otaRateplanId: channelRateplanId,
                  rateplanIds: selectedValue
                }
              },
              pmsRateplanId: pmsRateplanId,
              otaRateplanId: channelRateplanId
            }
          }
        }));
      }
    }
    
    if (type === 'systemRateplan') {
      setMappingParam(prev => ({
        ...prev,
        mapping: {
          ...prev.mapping,
          [otaCatId.otaCatId]: {
            ...prev.mapping[otaCatId.otaCatId],
            selectedRatePlans: {
              ...prev.mapping[otaCatId.otaCatId].selectedRatePlans,
              [otaCatId.channelRateplanId]: {
                ...prev.mapping[otaCatId.otaCatId].selectedRatePlans[otaCatId.channelRateplanId],
                system_rate_plan_code: e.target.value
              }
            }
          }
        }
      }));
    }

    if (type === 'currency') {
      setMappingParam(prev => ({
        ...prev,
        currency: e.target.value
      }));
    }
    
    if (type === 'channel_hotel_id') {
      setMappingParam(prev => ({
        ...prev,
        channelHotelId: e.target.value,
        pmsHotelId: hotelId
      }));
    }
    
    if (type === 'username') {
      setMappingParam(prev => ({
        ...prev,
        username: e.target.value
      }));
    }
    
    if (type === 'password') {
      setMappingParam(prev => ({
        ...prev,
        password: e.target.value
      }));
    }
  };

  return (
    <Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row gutters-5">
          <div className="col-xs justify-content-center fnt18 tu">
            {mappingParam.sync === 'add'
              ? <a className="cursor_p color6_1" onClick={() => navigator('/channelmanager/allchannel')}>
                All Channels
              </a> : <a className="cursor_p color6_1" onClick={() => navigate('/channelmanager/mychannel')}>
                My Channels
              </a>}{' '}
            <i className="fa fa-angle-right"></i>{' '}
            <a className="color2_6">
              {otaData.ota_name}
            </a>
          </div>
          <div className="col-xs fnt16">
            <div className="cover tr">
              {/* <div className="inline align_middle marg_left10" ng-show="!statusValue && cutOffOTA[data.otaName] !== undefined">
                  <a className="disblock pad_top_bot5 pad_lft_rht15 btn1 pop_clk" data-popup="popup_1" href="javascript:void(0)">Cut-off</a>
                </div> */}

                {channelStatus === 'active' &&
                  <Fragment>
                    <div className="inline align_middle marg_left10 cursor_p">
                      <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={reSyncData}>Re-Sync</a>
                    </div>
                    {checkRole('property_stop_sale')
                      ? <div className="inline align_middle marg_left10 offset_wrap cursor_p">
                        <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => changeStatus(false)}>Stop Sale</a>
                      </div> : ''}
                  </Fragment>}
                {channelStatus === 'de-active' &&
                  <Fragment>
                    <div className="inline align_middle marg_left10 cursor_p">
                      <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => changeStatus(true)}>Start Sale</a>
                    </div>
                    {checkRole('disconnect_mapping')
                      ? <div className="inline align_middle marg_left10 offset_wrap cursor_p">
                        <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={disconnect}>Disconnect</a>
                      </div> : ''}
                  </Fragment>}
            </div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`} >
          {message}
        </div>
      ) : ''}
      <div className="container pad_top_bot10 text-start">
        <div className="container-fluid pad_lft_rht15">
          <div className="cover border_b_1 border_color_1 fnt14 marg_bottom20">
            <div className="row no-gutters">
              <div className="col-xs-12 col-md-2">
                <div className="pad_lft_rht10 pad_top_bot20 ovr listlogo">
                  <img src={otaData.logoPath} className="images"/>
                </div>
              </div>
              <div className="col-xs-12 col-md">
                <div className="pad_lft_rht10 pad_top_bot20 ovr">
                  <div className="ovr color6_1 fnt16">{otaData.ota_desc}</div>
                </div>
              </div>
              {(Object.keys(data).length > 0 && typeof otaData.connected !== 'undefined') && <div className="col-xs-12 col-md-3">
                <div className="cover pad_top_bot20 ovr tc color6_1">
                  <div className="ovr marg_bottom8">Channel Hotel Id : { data.mappedArray && data.mappedArray.channel_hotel_id }</div>
                  <div className="row gutters-5">
                    {checkRole('edit_mapping')
                      ? <div className="col-xs-6">
                        {channelStatus === 'active' && <div className="ovr nowrap pad_top_bot5 pad_lft_rht15 fnt14 cursor_p btn1" onClick={() => editMapping('edit')}>Edit Mapping</div>}
                      </div> : ''}
                    <div className="col-xs-6">
                      <div className="ovr nowrap pad_top_bot5 pad_lft_rht15 fnt14 cursor_p btn1" onClick={() => editMapping('cancel')}>Cancel</div>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
          {(showMappingData && !showEditMapping && Object.keys(data).length > 0) &&
            <MappingData
              channelConfigData={data}
              otaData={otaData}
              currencyList={currencyList}
              handelCategoryChange={handelCategoryChange}
              handelParamChange={handelParamChange}
              categoryOptionsObject={categoryOptionsObject}
              pmsCategorySelected={pmsCategorySelected}
              mappingParam={mappingParam}
            />}
          {(!showMappingData && showEditMapping) &&
            <EditMapping
              channelConfigData={data}
              otaData={otaData}
              currencyList={currencyList}
              categoryOptionsObject={categoryOptionsObject}
              pmsCategorySelected={pmsCategorySelected}
              mappingParam={mappingParam}
              showError={showError}
              errorMessage={message}
              handelCategoryChange={handelCategoryChange}
              handelParamChange={handelParamChange}
              setChannelConfig={setChannelConfig}
              getChannelConfig={getChannelConfig}
              showConfigMessage={showConfigMessage}
            />}
        </div>
      </div>
    </Fragment>
  );
};

export default ChannelDetails;
